// extracted by mini-css-extract-plugin
export default {"number":"DetailRow_number__daPFb","remove":"DetailRow_remove__KatVa"};